/** 本檔案包含
 * > 1. 登入者權限內各分店的合約／簡訊點數摘要（右上角提醒、分店卡片）
 * > 2. 單一分店合約、點數、加值方案與匯款資訊
 * > 3. 簡訊發送紀錄（手機號碼由後端依權限遮罩）與匯出
 * > 4. 費用紀錄與匯出
 * > 5. 建立簡訊加值待收款訂單（不會加點，收款確認由黑曜雲人員處理）
 */
import { getToken } from "../services/reduxStoreService";
import { request } from "./type";

const router = "branchContracts";

const apiGetBranchContractSummary = () => request("get", `${router}/summary`, getToken());

const apiGetBranchContract = (branchId) => request("get", `${router}/${branchId}`, getToken());

const apiGetBranchSmsLogs = (branchId, { page = 1, pageSize = 20 } = {}) =>
  request("get", `${router}/${branchId}/sms-logs`, getToken(), null, { params: { page, pageSize } });

const apiExportBranchSmsLogs = (branchId) =>
  request("get", `${router}/${branchId}/sms-logs/export`, getToken(), null, { responseType: "blob" });

const apiGetBranchFees = (branchId) => request("get", `${router}/${branchId}/fees`, getToken());

const apiExportBranchFees = (branchId) =>
  request("get", `${router}/${branchId}/fees/export`, getToken(), null, { responseType: "blob" });

const apiCreateSmsTopupOrder = (branchId, planCode) =>
  request("post", `${router}/${branchId}/sms-topup-orders`, getToken(), { planCode });

export {
  apiGetBranchContractSummary,
  apiGetBranchContract,
  apiGetBranchSmsLogs,
  apiExportBranchSmsLogs,
  apiGetBranchFees,
  apiExportBranchFees,
  apiCreateSmsTopupOrder,
};
